import React from 'react';
import { getCoverGradient } from '../../services/cover';

interface GeneratedCoverProps {
  title: string;
  author: string;
  genre?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

export const GeneratedCover: React.FC<GeneratedCoverProps> = ({ 
  title, 
  author, 
  genre, 
  size = 'md',
  className = ''
}) => {
  const gradient = getCoverGradient(title + author);
  
  const sizeClasses = {
    sm: "w-16 h-24 text-[0.5rem]",
    md: "w-24 h-36 text-xs",
    lg: "w-32 h-48 text-sm",
    xl: "w-48 h-72 text-base", // Hero size
  };

  return (
    <div className={`relative rounded-sm shadow-md overflow-hidden flex flex-col p-2 select-none bg-gradient-to-br ${gradient} ${sizeClasses[size]} ${className}`}>
      {/* Spine effect */}
      <div className="absolute left-0 top-0 bottom-0 w-[2px] bg-white/20 z-10" />
      <div className="absolute left-[3px] top-0 bottom-0 w-[1px] bg-black/10 z-10" />
      
      {/* Content */}
      <div className="flex-1 flex flex-col justify-between z-0 h-full">
        <div className="mt-2">
          <h3 className="font-serif font-bold text-white leading-tight line-clamp-3 text-shadow-sm uppercase tracking-wider">
            {title}
          </h3>
          <p className="font-sans text-white/80 mt-1 font-medium truncate">
            {author}
          </p>
        </div>
        
        {genre && (
          <div className="self-start">
             <span className="inline-block px-1.5 py-0.5 rounded-full bg-black/20 text-white/90 font-medium backdrop-blur-sm scale-90 origin-bottom-left">
              {genre}
             </span>
          </div>
        )}
      </div>

      {/* Texture overlay */}
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/paper.png')] opacity-30 mix-blend-overlay pointer-events-none" />
    </div>
  );
};
